import React from 'react';
import { cx } from './cx';

// §1.5 — the one micro-label style. Column heads, section eyebrows, StatBox
// labels, filter-group labels, form labels. There are no size, weight, or
// color variants (§9.9): if a label needs more emphasis it is not a micro
// label, it is a `title`.
//
// carbon-300 rather than the carbon-400 originally specified — this style
// lives on panels, and carbon-400 is 4.25:1 on carbon-850. See §1.5 / §2.1.
const BASE = 'text-micro uppercase text-carbon-300';

export default function MicroLabel({ as: As = 'span', className, ...rest }) {
  return <As className={cx(BASE, className)} {...rest} />;
}
